const getBoldItemName = item => <strong>{item.name}</strong>;

export default getBoldItemName;
